import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

function ReusableModal({ open, onClose, title, children, actions,zIndex,maxWidth, hideCloseButton }) {
  return (
    <Dialog 
    open={open} 
    //  fullWidth 
      maxWidth={maxWidth}
      
    onClose={onClose}
    sx={{ zIndex: zIndex || 'auto',maxHeight:"100vh",textAlign: "center" }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: hideCloseButton ? 'flex-start' : 'space-between'}}>
        <span>{title}</span>
        {!hideCloseButton && onClose && (
          <Button 
          onClick={onClose} 
          color="primary"
          
          sx={{paddingLeft:"18px",bottom:'3px',right:'-24px'}}
          >
            Close
          </Button>
        )}
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
}

export default ReusableModal;